import React, {useEffect, useState} from "react";
import moment from "moment";

function HappyHour(start_date,start_hour) {
  // console.log(moment("01-08-2024", "DD-MM-YYYY").format("dddd"), start_hour);

  const dDay = moment("01-08-2024", "DD-MM-YYYY").format("dddd");
  const deadline = "August, 01, 2024, 17:59:00";
  const remInSec = Date.parse(deadline) - Date.parse(new Date());
  // console.log("remInSec:",remInSec);
  const [days, setDays] = React.useState(0);
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);

  const leading0 = (num) => {
    return num < 10 ? "0" + num : num;
  };

  const getTimeUntil = (deadline="August, 01, 2024, 17:59:00") => {
    const time = Date.parse(deadline) - Date.parse(new Date());
    if (time < 0) {
      setDays(0);
      setHours(0);
      setMinutes(0);
      setSeconds(0);
    } else {
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
      setMinutes(Math.floor((time / 1000 / 60) % 60));
      setSeconds(Math.floor((time / 1000) % 60));
    }
  };

  useEffect(() => {
    setInterval(() => getTimeUntil(deadline), 1000);

    return () => getTimeUntil(deadline);
  }, [deadline]);

  return (
    <div className="tw-w-full tw-bg-[#deecea] md:tw-h-[158px] sm:tw-h-[205px]" style={{paddingTop:'10px', paddingBottom:'10px'}}>
      <div className="pod-container">
        <div className="d-flex">
          <img
            src="/images/v2/delivery-van.png"
            alt="delivery"
            className="tw-h-[110px] tw-w-[110px]"
          />
          <span className="md:tw-w-[801px] tw-pl-[20px] tw-pr-[20px]" style={{font:'inter'}}>
            <strong className="tw-mb-[10px]" style={{lineHeight:'44px', fontSize:'20px', color:'#080445'}}>Happy Hour Delivery</strong><br />
            <p>Pay just <strong>N100.00</strong> for any delivery made between <span className="tw-font-semibold">5pm and 6pm</span> this <span className="tw-font-semibold">{dDay.toUpperCase()}</span>. Happy hour delivery is gonna be around for the next 3 months starting from August 1, 2024 </p>
            <p><a href="#" style={{color:'#6D60F6', fontSize:'15px', lineHeight:'21px'}}>Learn more</a></p>
          </span>
          {remInSec > 0 ? (
            <span className="md:tw-w-[342px] tw-pl-[30px] tw-pr-[20px] float-end" style={{font:'inter', paddingTop:'20px', paddingBottom:'20px'}}>
            <div className="d-flex tw-pb-[10px] gap-2 tw-justify-center" style={{textAlign:"center"}}>
              <img
                src="/images/icons/time.png"
                alt="time"
                className="tw-h-[20px] tw-w-[20px]"
              />
              <span style={{fontSize:'16px', lineHeight:'21px', fontWeight:'500'}}>Next deal starts in:</span>
            </div>
            <div className="d-flex tw-pb-[10px] gap-4 tw-justify-center" style={{textAlign:"center"}}>
              <div className="align-content-center" style={{height:'62px',width:'63px',borderRadius:'10px',padding:'10px',backgroundColor:'#FFFFFF', textAlign:"center"}}>
                <strong>{leading0(days)}</strong><br/>
                <span>Days</span>
              </div>
              <div className="align-content-center" style={{height:'62px',width:'63px',borderRadius:'10px',padding:'10px',backgroundColor:'#FFFFFF', textAlign:"center"}}>
                <strong>{leading0(hours)}</strong><br/>
                <span>Hours</span>
              </div>
              <div className="align-content-center" style={{height:'62px',width:'63px',borderRadius:'10px',padding:'10px',backgroundColor:'#FFFFFF',textAlign:"center"}}>
                <strong>{leading0(minutes)}</strong><br/>
                <span>Mins</span>
              </div>
              <div className="align-content-center" style={{height:'62px',width:'63px',borderRadius:'10px',padding:'10px',backgroundColor:'#FFFFFF',textAlign:"center"}}>
                <strong>{leading0(seconds)}</strong><br/>
                <span>Secs</span>
              </div>
            </div>
          </span>
          ):''}
        </div>
      </div>
    </div>
  )
}

export default HappyHour
